import React from 'react';
import PatientFormTemplate from '../components/PatientFormTemplate';

export default function PatientAQ10Form() {
    return (
        <PatientFormTemplate formTitle="Autism Spectrum Quotient (AQ-10)" />
    );
}
